import { TRANSPARENT, gridConfig, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getTitleSectionTypography = (props, breakpoint) => {
  var _props$titleSize = props.titleSize,
    titleSize = _props$titleSize === void 0 ? {} : _props$titleSize,
    _props$subTitleSize = props.subTitleSize,
    subTitleSize = _props$subTitleSize === void 0 ? {} : _props$subTitleSize,
    _props$useSmTypograph = props.useSmTypographyOnLg,
    useSmTypographyOnLg = _props$useSmTypograph === void 0 ? false : _props$useSmTypograph,
    _props$isInsideLeftCo = props.isInsideLeftColumn,
    isInsideLeftColumn = _props$isInsideLeftCo === void 0 ? false : _props$isInsideLeftCo;
  var isSmallScreen = breakpoint === 'xs' || breakpoint === 'sm';
  if (useSmTypographyOnLg) isSmallScreen = true;
  var titleTypeSmallScreen = (titleSize === null || titleSize === void 0 ? void 0 : titleSize.mobile) ? "body-para-" + (titleSize === null || titleSize === void 0 ? void 0 : titleSize.mobile) + "-bold" : 'body-para-md-bold';
  var titleTypeWebScreen = (titleSize === null || titleSize === void 0 ? void 0 : titleSize.web) ? "body-para-" + (titleSize === null || titleSize === void 0 ? void 0 : titleSize.web) + "-bold" : isInsideLeftColumn ? 'h6-bold' : 'h4-bold';
  var titleType = isSmallScreen ? titleTypeSmallScreen : titleTypeWebScreen;
  var subTitleTypeSmallScreen = (subTitleSize === null || subTitleSize === void 0 ? void 0 : subTitleSize.mobile) ? "body-para-" + (subTitleSize === null || subTitleSize === void 0 ? void 0 : subTitleSize.mobile) : 'body-para-sm';
  var subTitleTypeWebScreen = (subTitleSize === null || subTitleSize === void 0 ? void 0 : subTitleSize.web) ? "body-para-" + (subTitleSize === null || subTitleSize === void 0 ? void 0 : subTitleSize.web) : 'body-para-md';
  var subTitleType = isSmallScreen ? subTitleTypeSmallScreen : subTitleTypeWebScreen;
  return {
    titleType,
    subTitleType
  };
};
export var getTitleSectionStyles = (props, breakpoint) => {
  var _a, _b, _c, _d;
  var _props$hideTopPadding = props.hideTopPadding,
    hideTopPadding = _props$hideTopPadding === void 0 ? false : _props$hideTopPadding,
    _props$hideBottomPadd = props.hideBottomPadding,
    hideBottomPadding = _props$hideBottomPadd === void 0 ? false : _props$hideBottomPadd,
    _props$withTitleBotto = props.withTitleBottomMargin,
    withTitleBottomMargin = _props$withTitleBotto === void 0 ? false : _props$withTitleBotto,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? TRANSPARENT : _props$backgroundColo,
    _props$alignCenterTit = props.alignCenterTitle,
    alignCenterTitle = _props$alignCenterTit === void 0 ? {
      desktop: false,
      mobile: false
    } : _props$alignCenterTit,
    _props$alignCenterChi = props.alignCenterChildren,
    alignCenterChildren = _props$alignCenterChi === void 0 ? {
      desktop: false,
      mobile: false
    } : _props$alignCenterChi,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    _props$subTitle = props.subTitle,
    subTitle = _props$subTitle === void 0 ? '' : _props$subTitle,
    _props$hideTopMarginF = props.hideTopMarginFromChildren,
    hideTopMarginFromChildren = _props$hideTopMarginF === void 0 ? false : _props$hideTopMarginF;
  var spacing = tokens.spacing;
  var isSmallScreen = breakpoint === 'xs' || breakpoint === 'sm';
  var alignCenterTitleAndSubtitle = isSmallScreen ? alignCenterTitle === null || alignCenterTitle === void 0 ? void 0 : alignCenterTitle.mobile : alignCenterTitle === null || alignCenterTitle === void 0 ? void 0 : alignCenterTitle.desktop;
  var alignCenterTitleChildren = isSmallScreen ? alignCenterChildren === null || alignCenterChildren === void 0 ? void 0 : alignCenterChildren.mobile : alignCenterChildren === null || alignCenterChildren === void 0 ? void 0 : alignCenterChildren.desktop;
  var containerPadding = {
    top: isSmallScreen ? spacing.SPACING_36 : spacing.SPACING_60,
    bottom: isSmallScreen ? spacing.SPACING_36 : spacing.SPACING_60
  };
  var columnSpacing = (_c = (_b = (_a = gridConfig === null || gridConfig === void 0 ? void 0 : gridConfig.light) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b[breakpoint]) === null || _c === void 0 ? void 0 : _c.columnSpacing;
  var hasTitleOrSubTitle = !!title || !!subTitle;
  var hideChildrenMargin = hideTopMarginFromChildren ? hasTitleOrSubTitle : true;
  return StyleSheet.create({
    container: Object.assign(Object.assign(Object.assign({}, !hideTopPadding && {
      paddingTop: containerPadding.top
    }), !hideBottomPadding && {
      paddingBottom: containerPadding.bottom
    }), {
      backgroundColor
    }),
    titleContainer: Object.assign(Object.assign({
      paddingTop: isSmallScreen ? spacing.SPACING_20 : spacing.SPACING_32
    }, withTitleBottomMargin && {
      marginBottom: isSmallScreen ? spacing.SPACING_12 : spacing.SPACING_32
    }), alignCenterTitleAndSubtitle && {
      alignItems: 'center'
    }),
    actionCtaAndTitleContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    actionCtaStyle: {
      marginTop: isSmallScreen && spacing.SPACING_4,
      marginLeft: isSmallScreen && spacing.SPACING_12
    },
    subTitleContainer: Object.assign({
      paddingTop: isSmallScreen ? spacing.SPACING_4 : spacing.SPACING_8
    }, alignCenterTitleAndSubtitle && {
      alignItems: 'center'
    }),
    childContainer: Object.assign(Object.assign({}, alignCenterTitleChildren && {
      alignItems: 'center'
    }), hideChildrenMargin && {
      marginTop: (_d = tokens.spacing) === null || _d === void 0 ? void 0 : _d[columnSpacing]
    })
  });
};